<template>
  <v-container>
    <v-breadcrumbs :items="itemsForNavigation" style="padding: 5px 0px;"></v-breadcrumbs>
    <v-color-picker v-if="false"></v-color-picker>
    <v-data-table v-if="false"></v-data-table>
        <RestTable 
        v-if="pageMetadata && allowAnyAction" 
        :resource="pageMetadata.resource" 
        :filters="pageMetadata.filters"
        :itemsPerPageOptions="pageMetadata.itemsPerPageOptions" 
        :processDataOn="pageMetadata.processDataOn" 
        :dataExtraction="dataExtraction"
        :excludedHeaders="pageMetadata.excludedHeaders"
        :itemsPerPageText="pageMetadata.itemsPerPageText"
        :addBtn="pageMetadata.addBtn"
        :editFormElements="updateFields"
        :insertFormElements="insertFields"
        :updateOpts="editModalOpts"
        :insertOpts="insertModalOpts"
        :extractInsertErrors="extractErrors"
        :extractUpdateErrors="extractErrors"
        :messages="pageMetadata.messages"
        :useInsert="useInsert"
        :useEdit="useUpdate"
        :useDelete="useDelete"
        :headers="headers"
        :tableProps="tableProps"
        :specializedColumns="specializedColumns"
        searchTitle="$allowedFilters"
        :formatters="formatters"
        :persistentDialog="pageMetadata.persistentDialog"
        :showDeleteErrors="showDeleteErrors"
        :customDialog="customDialog"
        :filterPosition="filterPosition"
        :searchSubmit="searchSubmit"
        :columnWidth="columnWidth"
        @updateSuccess="snackbar = true"
        @insertSuccess="snackbar = true"
        :custom-sort="customSort"
        :headerColor="primaryColor"
        :modalHeaderColor="primaryColor"
        ref="restTable"
      >
        <ImportBtn v-if="importProps" :bulkProps="importProps" v-useCase="importProps.useCase"/>
      </RestTable>

      <v-row class="pl-3 pt-3" v-if="showExport">
        <v-btn color="primary" small @click="exportAsCsv" class="mr-2 font-weight-light">CSV</v-btn>
        <v-btn color="primary" small @click="exportAsExcel" class="mr-2 font-weight-light">Excel</v-btn>
        <v-btn color="primary" small @click="exportAsPdf" class="mr-2 font-weight-light">PDF</v-btn>
      </v-row>

      <v-snackbar :timeout="1000" right bottom color="success" dark v-model="snackbar">
      <v-card-text> {{ $t("apiSuccessMsg") }} </v-card-text>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          X
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar :timeout="5000" right top color="error" dark v-model="snackbarError">
      <v-card-text> {{ errorMessage }} </v-card-text>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbarError = false"
        >
          X
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import defaults from './defaults.json'
import formatDate from '@/utils/formatDateHelper.js'
import store from '../../../store/store'
import { useCaseMap } from '../../../utils/useCase/useCaseMap'
import ImportBtn from '@/components/tables/BulkImportButton'
import dataTableSort from '@/utils/dataTableSort.js'
import navigationMixin from '../navigationMixin'
import { mapState } from 'vuex'
import Papa from 'papaparse'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
const Excel = require('exceljs')

export default {
  components: {
    ImportBtn
  },
  name: 'RestCrudPage',
  props: {
    page: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pageMetadata: undefined,
      snackbar: false,
      snackbarError: false,
      errorMessage: '',
      itemsForNavigation: [],
      showExport: false,
    }
  },
  async mounted() {
    let pageSource = this.page
    if (
      pageSource == 'tenantsettings' &&
      JSON.parse(store.getters['user/jwtData'].UserData).IsTenantDaughtersAdmin
    ) {
      pageSource = 'alternatetenantsettings'
    }
    const pageData = await import(`./pages/${pageSource}.json`)
    this.pageMetadata = { ...defaults, ...pageData }
    if (this.sorts) {
      dataTableSort.setSorts(this.sorts)
    }
    this.itemsForNavigation = await this.setBreadcrumbs()
    this.showExport = this.pageMetadata.showExport
  },
  computed: {
    formatters() {
      var that = this
      return {
        date: that.dateFormatter,
        lastLoginTime: function(value) {
          if (!value) {
            return
          }
          return formatDate(value, 'long', true)
        },
        lastActionExecutedAt: function(value) {
          if (!value) {
            return
          }
          return formatDate(value, 'long', true)
        },
        icon: function(value) {
          return process.env.VUE_APP_S3_DOMAIN + '/icons/' + value
        },
        birthDate: function(value) {
          if (!value) {
            return
          }
          return that.dateFormatter(value, 'short')
        },
        executedTime: function(value) {
          return formatDate(value, 'long', true)
        },
        firstPacketRecievedAt: function(value) {
          if(!value) {
            return
          }
          return formatDate(value, 'long', true)
        },
        lastPacketRecievedAt: function(value) {
          if(!value) {
            return
          }
          return formatDate(value, 'long', true)
        },
        createdAt: function(value) {
          if(!value) {
            return
          }
          return formatDate(value, 'long', true)
        }
      }
    },
    importProps() {
      return this.pageMetadata.import
    },
    useInsert() {
      return this.useCaseAllowed(this.pageMetadata.useCases.insert)
    },
    useUpdate() {
      return this.useCaseAllowed(this.pageMetadata.useCases.update)
    },
    useDelete() {
      return this.useCaseAllowed(this.pageMetadata.useCases.delete)
    },
    allowAnyAction() {
      return this.useCaseAllowed(this.pageMetadata.useCases.search)
    },
    insertFields() {
      return this.pageMetadata.insertFields
    },
    updateFields() {
      return this.pageMetadata.updateFields
        ? this.pageMetadata.updateFields
        : this.pageMetadata.insertFields
    },
    insertModalOpts() {
      return this.pageMetadata.insertModalOpts
    },
    filterPosition() {
      return this.pageMetadata.filterPosition
    },
    searchSubmit() {
      return this.pageMetadata.searchSubmit
    },
    editModalOpts() {
      return this.pageMetadata.editModalOpts
        ? this.pageMetadata.editModalOpts
        : this.pageMetadata.insertModalOpts
    },
    dataExtraction() {
      if (
        this.pageMetadata.processDataOn == 'client' ||
        this.pageMetadata.processDataOn == 'mixed'
      ) {
        return undefined
      }
      return this.pageMetadata.dataExtraction
    },
    headers() {
      return this.pageMetadata.headers
    },
    specializedColumns() {
      return this.pageMetadata.specializedColumns
    },
    tableProps() {
      this.pageMetadata.tableProps.noDataText = this.$t('noData')
      this.pageMetadata.tableProps.loadingText = this.$t('loadingData')
      if (this.sorts) {
        this.pageMetadata.tableProps.customSort = this.customSort
      }
      return this.pageMetadata.tableProps
    },
    customDialog() {
      return this.pageMetadata.customDialog
    },
    columnWidth() {
      return this.pageMetadata.columnWidth
        ? this.pageMetadata.columnWidth
        : 'auto'
    },
    customSort: () => dataTableSort.sort,
    sorts() {
      return this.pageMetadata.sorts
    },
    headersForExport() {
      return this.headers.filter(x => x.value != 'action')
    },
    ...mapState('colors', ['primaryColor', 'secondaryColor'])
  },
  mixins: [navigationMixin],
  methods: {
    useCaseAllowed(useCaseName) {
      if (useCaseName == 'NONE') {
        return true
      }

      if (!useCaseName) {
        throw new Error(
          `Missing use-case. Please review your json config file.`
        )
      }
      var useCaseId = useCaseMap[useCaseName]

      if (!useCaseId) {
        throw new Error(
          `Provided UseCase (${useCaseName}) did not resolve to any use case ID. Plase review your json config file.`
        )
      }

      return JSON.parse(
        store.getters['user/jwtData'].UserData
      ).AllowedUseCaseIds.includes(useCaseId)
    },
    dateFormatter(value, length = 'short') {
      if (!value) {
        return
      }
      return formatDate(value, length)
    },
    extractErrors(response) {
      var errors = response.errors.map(x => {
        return {
          propertyName: this.capitalizeFirstLetter(x.PropertyName),
          error: x.Error
        }
      })

      return errors
    },
    showDeleteErrors(error) {
      let errorString = ''
      for (let singleError of error.errors) {
        errorString += singleError.Error + '\n'
      }
      this.snackbarError = true
      this.errorMessage = errorString
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toLowerCase() + string.slice(1)
    },
    prepareDataForExport() {
      let preparedData = []
      let tempObject = {}

      let tableItems = this.$refs.restTable.$refs.table.$children.find(x => x.$options._componentTag == "v-data-table").internalCurrentItems;
      tableItems.forEach(x => {
        tempObject = {}
        for (var prop in x) {
          var foundHeader = this.headers.find(h => {
            return h.value == prop
          })
          if (foundHeader) {
            var translatedProp = foundHeader.text
            tempObject[translatedProp] = x[prop]
          }
        }
        preparedData.push(tempObject)
      })

      return preparedData
    },
    exportAsCsv() {
      let preparedData = this.prepareDataForExport()
      
      var blob = new Blob(['\ufeff', Papa.unparse(preparedData)], {
        type: 'text/csv;charset=utf-8;'
      })

      var link = document.createElement('a')

      var fileName = this.pageMetadata.resource.substring(1);
      var url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute(
        'download',
        `${fileName}.csv`
      )
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    exportAsPdf() {
      var source = this.$refs.restTable.$refs.table.$children.find(x => x.$options._componentTag == "v-data-table")
      let headers = []
      let rows = []
      let pdfName = this.pageMetadata.resource.substring(1)

      this.headersForExport.forEach(header => {
        headers.push({
          content: header.text,
          value: header.value,
          styles: { minCellWidth: 15, fontSize: 6 }
        })
      })

      headers.forEach(h => {
        h.content = h.content.replace('č', 'c')
        h.content = h.content.replace('Č', 'č')
        h.content = h.content.replace('đ', 'dj')
        h.content = h.content.replace('Đ', 'Dj')
      })

      source.internalCurrentItems.forEach(element => {
        var temp = []
        headers.forEach(header => {
          temp.push({
            content: element[header.value] == null ? '' : element[header.value],
            styles: { minCellWidth: 15, fontSize: 6 }
          })

        })

        rows.push(temp)
      })
      
      var doc = new jsPDF('landscape')
      doc.autoTable({
        head: [headers],
        body: rows,
        startY: 10
      })
      doc.save(pdfName + '.pdf')
    },
    prepareColumnsForExcel() {
      let columns = []

      this.headersForExport.forEach(header => {
        let column = {
          name: header.value,
          key: header.value
        }
        columns.push(column)

      })

      return columns
    },
    prepareHeadersForExcel() {
      let headers = {}

      this.headersForExport.forEach(header => {
        headers[header.value] = header.text
      })

      return headers
    },
    prepareDataForExcel() {
      let preparedExcelData = [];

      let tableItems = this.$refs.restTable.$refs.table.$children.find(x => x.$options._componentTag == "v-data-table").internalCurrentItems;
      tableItems.forEach(element => {
        var temp = []
        this.headersForExport.forEach(header => {
          temp.push(element[header.value] == null ? "" : element[header.value])
        })
        preparedExcelData.push(temp)
      });

      return preparedExcelData;
    },
    exportAsExcel() {
      const workbook = new Excel.Workbook()
      workbook.creator = 'Puregreen'
      workbook.lastModifiedBy = 'Puregreen'

      var fileName = this.pageMetadata.resource.substring(1);
      const ws = workbook.addWorksheet(fileName)

      const columns = this.prepareColumnsForExcel()
      ws.columns = columns

      ws.insertRow(1, this.prepareHeadersForExcel())
      ws.insertRows(2, this.prepareDataForExcel())

      ws.columns.forEach(column => {
        var dataMax = 0
          column.eachCell({ includeEmpty: true }, function(cell) {
              var columnLength = cell.value ? cell.value.length : 0
              if (columnLength > dataMax) {
                dataMax = columnLength
              }
          })
          column.width = dataMax < 10 ? 10 : dataMax + 5
      })

      workbook.xlsx.writeBuffer().then(function(data) {
        const blob = new Blob([data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = `${fileName}.xlsx`
        anchor.click()
        window.URL.revokeObjectURL(url)
      })
    }
  }
}
</script>

<style>
#headerSlot {
  margin-top: 17px;
}
#apiTableFilters {
  padding: 10px;
  margin-top: 17px !important;
}

.v-application .text-button,
.v-application .text-caption {
  line-height: normal;
  font-family: 'Futura Md BT' !important;
}

.v-icon.v-icon {
  font-size: 18px;
}
</style>
